module.exports = __webpack_public_path__ + "img/weixin.35e0f3db.jpg";